/**
 * Enhanced SEO Schema Generator
 * 
 * This script generates rich structured data for products and collections
 * to improve search engine visibility and rich snippet display.
 */

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Enhanced SEO Schema Generator: Initializing');
    
    // Function to generate product schema
    function generateProductSchema() {
      // Check if we're on a product page
      if (!document.querySelector('.Product') && !document.querySelector('[data-section-type="product"]')) {
        return;
      }
      
      try {
        // Get product data from the page
        const productName = document.querySelector('.ProductMeta__Title, .Product__Title, h1').textContent.trim();
        const productDescription = document.querySelector('.ProductMeta__Description, .Product__Description, .rte').textContent.trim();
        const productPrice = document.querySelector('.ProductMeta__Price, .Product__Price, [data-product-price]').textContent.trim();
        const productImage = document.querySelector('.Product__Gallery img, .ProductGallery img');
        const productImageUrl = productImage ? productImage.src : '';
        const productUrl = window.location.href;
        const brand = document.querySelector('.ProductMeta__Vendor, .Product__Vendor') ? 
                      document.querySelector('.ProductMeta__Vendor, .Product__Vendor').textContent.trim() : '';
        
        // Get availability
        const soldOut = document.querySelector('.ProductForm__AddToCart[disabled], .Product__AddToCart[disabled]');
        const availability = soldOut ? 'OutOfStock' : 'InStock';
        
        // Get reviews if available
        const reviewElements = document.querySelectorAll('.ProductReviews, .Product__Reviews, .yotpo-review');
        let reviews = [];
        
        reviewElements.forEach(function(review) {
          const rating = review.querySelector('[data-rating], .yotpo-stars');
          const ratingValue = rating ? parseFloat(rating.getAttribute('data-rating') || '5') : 5;
          const reviewText = review.querySelector('.ReviewText, .yotpo-review-content').textContent.trim();
          const reviewAuthor = review.querySelector('.ReviewAuthor, .yotpo-user-name').textContent.trim();
          
          reviews.push({
            '@type': 'Review',
            'reviewRating': {
              '@type': 'Rating',
              'ratingValue': ratingValue,
              'bestRating': '5'
            },
            'author': {
              '@type': 'Person',
              'name': reviewAuthor
            },
            'reviewBody': reviewText
          });
        });
        
        // Get aggregate rating if available
        let aggregateRating = null;
        const ratingElement = document.querySelector('.ProductMeta__Rating, .Product__Rating, .yotpo-stars');
        
        if (ratingElement) {
          const ratingValue = parseFloat(ratingElement.getAttribute('data-rating') || '4.5');
          const reviewCount = parseInt(ratingElement.getAttribute('data-count') || '10');
          
          aggregateRating = {
            '@type': 'AggregateRating',
            'ratingValue': ratingValue,
            'reviewCount': reviewCount,
            'bestRating': '5',
            'worstRating': '1'
          };
        }
        
        // Get offers data
        const priceValue = parseFloat(productPrice.replace(/[^0-9.]/g, ''));
        const currencyMatch = productPrice.match(/[£$€]/);
        const currency = currencyMatch ? currencyMatch[0] : 'GBP';
        const currencyCode = {
          '£': 'GBP',
          '$': 'USD',
          '€': 'EUR'
        }[currency] || 'GBP';
        
        // Create the schema
        const productSchema = {
          '@context': 'https://schema.org/',
          '@type': 'Product',
          'name': productName,
          'description': productDescription,
          'image': productImageUrl,
          'url': productUrl,
          'sku': window.location.pathname.split('/').pop(),
          'mpn': window.location.pathname.split('/').pop(),
          'brand': {
            '@type': 'Brand',
            'name': brand
          },
          'offers': {
            '@type': 'Offer',
            'url': productUrl,
            'price': priceValue,
            'priceCurrency': currencyCode,
            'availability': 'https://schema.org/' + availability,
            'priceValidUntil': new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0]
          }
        };
        
        // Add reviews if available
        if (reviews.length > 0) {
          productSchema.review = reviews;
        }
        
        // Add aggregate rating if available
        if (aggregateRating) {
          productSchema.aggregateRating = aggregateRating;
        }
        
        // Add the schema to the page
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(productSchema);
        document.head.appendChild(script);
        
        console.log('Enhanced SEO Schema Generator: Added Product schema');
      } catch (e) {
        console.error('Enhanced SEO Schema Generator: Error generating Product schema', e);
      }
    }
    
    // Function to generate collection schema
    function generateCollectionSchema() {
      // Check if we're on a collection page
      if (!document.querySelector('.Collection') && !document.querySelector('[data-section-type="collection"]')) {
        return;
      }
      
      try {
        // Get collection data from the page
        const collectionName = document.querySelector('.CollectionHero__Title, .Collection__Title, h1').textContent.trim();
        const collectionDescription = document.querySelector('.CollectionHero__Description, .Collection__Description, .rte');
        const collectionDescriptionText = collectionDescription ? collectionDescription.textContent.trim() : '';
        const collectionUrl = window.location.href;
        
        // Get all products in the collection
        const productElements = document.querySelectorAll('.ProductItem, .Collection__Product');
        let products = [];
        
        productElements.forEach(function(product) {
          const productName = product.querySelector('.ProductItem__Title, .Product__Title').textContent.trim();
          const productUrl = product.querySelector('a').href;
          const productImage = product.querySelector('img');
          const productImageUrl = productImage ? productImage.src : '';
          const productPrice = product.querySelector('.ProductItem__Price, .Product__Price').textContent.trim();
          
          products.push({
            '@type': 'Product',
            'name': productName,
            'url': productUrl,
            'image': productImageUrl
          });
        });
        
        // Create the schema
        const collectionSchema = {
          '@context': 'https://schema.org/',
          '@type': 'CollectionPage',
          'name': collectionName,
          'description': collectionDescriptionText,
          'url': collectionUrl,
          'mainEntity': {
            '@type': 'ItemList',
            'itemListElement': products.map(function(product, index) {
              return {
                '@type': 'ListItem',
                'position': index + 1,
                'item': product
              };
            })
          }
        };
        
        // Add the schema to the page
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(collectionSchema);
        document.head.appendChild(script);
        
        console.log('Enhanced SEO Schema Generator: Added Collection schema');
      } catch (e) {
        console.error('Enhanced SEO Schema Generator: Error generating Collection schema', e);
      }
    }
    
    // Function to generate breadcrumb schema
    function generateBreadcrumbSchema() {
      try {
        // Get breadcrumb data from the page
        const breadcrumbElements = document.querySelectorAll('.Breadcrumb__Item, .breadcrumb-item, .breadcrumb a');
        
        if (breadcrumbElements.length === 0) {
          return;
        }
        
        let breadcrumbItems = [];
        
        breadcrumbElements.forEach(function(item, index) {
          const name = item.textContent.trim();
          const url = item.href || window.location.origin;
          
          breadcrumbItems.push({
            '@type': 'ListItem',
            'position': index + 1,
            'name': name,
            'item': url
          });
        });
        
        // Create the schema
        const breadcrumbSchema = {
          '@context': 'https://schema.org/',
          '@type': 'BreadcrumbList',
          'itemListElement': breadcrumbItems
        };
        
        // Add the schema to the page
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(script);
        
        console.log('Enhanced SEO Schema Generator: Added Breadcrumb schema');
      } catch (e) {
        console.error('Enhanced SEO Schema Generator: Error generating Breadcrumb schema', e);
      }
    }
    
    // Function to generate FAQ schema if FAQ content exists
    function generateFAQSchema() {
      try {
        // Look for FAQ sections
        const faqContainers = document.querySelectorAll('.FAQ, .Faq, .faq, [data-section-type="faq"]');
        
        if (faqContainers.length === 0) {
          return;
        }
        
        let faqItems = [];
        
        faqContainers.forEach(function(container) {
          // Look for question-answer pairs
          const questions = container.querySelectorAll('.Faq__Question, .faq-question, .accordion-title');
          const answers = container.querySelectorAll('.Faq__Answer, .faq-answer, .accordion-content');
          
          for (let i = 0; i < questions.length; i++) {
            if (answers[i]) {
              faqItems.push({
                '@type': 'Question',
                'name': questions[i].textContent.trim(),
                'acceptedAnswer': {
                  '@type': 'Answer',
                  'text': answers[i].textContent.trim()
                }
              });
            }
          }
        });
        
        if (faqItems.length === 0) {
          return;
        }
        
        // Create the schema
        const faqSchema = {
          '@context': 'https://schema.org/',
          '@type': 'FAQPage',
          'mainEntity': faqItems
        };
        
        // Add the schema to the page
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(faqSchema);
        document.head.appendChild(script);
        
        console.log('Enhanced SEO Schema Generator: Added FAQ schema');
      } catch (e) {
        console.error('Enhanced SEO Schema Generator: Error generating FAQ schema', e);
      }
    }
    
    // Run all schema generators
    generateProductSchema();
    generateCollectionSchema();
    generateBreadcrumbSchema();
    generateFAQSchema();
    
    console.log('Enhanced SEO Schema Generator: Initialization complete');
  });
})();
